import { useTranslation } from 'react-i18next';
import './Auth.css';

interface ForgotUsernameProps {
  onClose: () => void;
  onBackToSignIn: () => void;
}

export default function ForgotUsername({ onClose, onBackToSignIn }: ForgotUsernameProps) {
  const { t } = useTranslation();

  return (
    <div className="auth-form">
      <div className="auth-info">
        <h3>{t('auth.forgotUsername')}</h3>
        <p className="auth-description">{t('auth.forgotUsernameDescription')}</p>
        <ul className="auth-help-list">
          <li>{t('auth.forgotUsernameHelp1')}</li>
          <li>{t('auth.forgotUsernameHelp2')}</li>
          <li>{t('auth.forgotUsernameHelp3')}</li>
        </ul>
      </div>

      <div className="auth-footer">
        <button
          type="button"
          className="auth-submit-button"
          onClick={onBackToSignIn}
        >
          {t('auth.backToSignIn')}
        </button>
        <p className="auth-close-text">
          <button type="button" className="auth-link" onClick={onClose}>
            {t('auth.close')}
          </button>
        </p>
      </div>
    </div>
  );
}
